export default "__VITE_ASSET__mei9LYOo__"